<section class="grouped-status-chart">
  <header class="grouped-status-chart__header">
    <div>
      <p class="grouped-status-chart__eyebrow">Price Analysis</p>
      <h3>{{ data?.title || 'Grouped Bar Chart With Status Table' }}</h3>
    </div>
  </header>

  <div class="grouped-status-chart__state" *ngIf="loading">Loading analysis...</div>
  <div class="grouped-status-chart__state grouped-status-chart__state--error" *ngIf="!loading && errorMessage">
    {{ errorMessage }}
  </div>

  <ng-container *ngIf="!loading && !errorMessage">
    <div class="grouped-status-chart__empty" *ngIf="!rows.length">No data available.</div>

    <div class="grouped-status-chart__table" *ngIf="rows.length">
      <div class="grouped-status-chart__table-head">
        <span>Equipment</span>
        <span>Price Comparison</span>
        <span>Status Summary</span>
      </div>

      <div class="grouped-status-chart__row" *ngFor="let row of rows; trackBy: trackRow">
        <div class="grouped-status-chart__equipment">
          <strong>{{ row.equipmentLabel }}</strong>
        </div>

        <div class="grouped-status-chart__bars">
          <div class="metric">
            <span class="metric__label">List</span>
            <div class="metric__track"><span class="metric__fill metric__fill--list" [style.width.%]="barWidth(row.listPrice)"></span></div>
            <span class="metric__value">{{ formatCurrency(row.listPrice) }}</span>
          </div>

          <div class="metric">
            <span class="metric__label">Computed</span>
            <div class="metric__track"><span class="metric__fill metric__fill--computed" [style.width.%]="barWidth(row.computedPrice)"></span></div>
            <span class="metric__value">{{ formatCurrency(row.computedPrice) }}</span>
          </div>

          <div class="metric">
            <span class="metric__label">Recommended</span>
            <div class="metric__track"><span class="metric__fill metric__fill--recommended" [style.width.%]="barWidth(row.recommendedPrice)"></span></div>
            <span class="metric__value">{{ formatCurrency(row.recommendedPrice) }}</span>
          </div>
        </div>

        <div class="grouped-status-chart__statuses">
          <span class="status-pill" [ngClass]="statusClass(row.tcoStatus)">TCO: {{ row.tcoStatus || 'N/A' }}</span>
          <span class="status-pill" [ngClass]="statusClass(row.engineUptimeStatus)">Uptime: {{ row.engineUptimeStatus || 'N/A' }}</span>
          <span class="status-pill" [ngClass]="statusClass(row.priceDynamicsStatus)">Dynamics: {{ row.priceDynamicsStatus || 'N/A' }}</span>
        </div>
      </div>
    </div>
  </ng-container>
</section>
